// extracted by mini-css-extract-plugin
export default {"accordion_button":"style_accordion_button__jKiQb","collapsed":"style_collapsed__tvTu+","accordionScreenStyle":"style_accordionScreenStyle__2MggZ"};